import { t } from "../../i18n";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function ErrorState({ title, message, onRetry, action }: ErrorStateProps) {
  return (
    <div className="app-error-state">
      <div className="app-error-mark">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      </div>
      <h3>{title ?? t("commonError")}</h3>
      <p>{message}</p>
      <div className="app-error-actions">
        {onRetry && (
          <button
            onClick={onRetry}
            className="app-secondary-button"
          >
            {t("commonRetry")}
          </button>
        )}
        {action && (
          <button
            onClick={action.onClick}
            className="app-primary-button"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
